<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="6">
      <h1>Ингредиенты</h1>
    </v-col>
    <v-col cols="3"></v-col>
    <v-col cols="3" class="search-col">
      <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Поиск"
          single-line
          otlined
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col cols="12" class="text-right pb-2">
            <v-btn @click="$router.push({ name: 'modifier-create'})">Создать</v-btn>
        </v-col>
        <v-col cols="12" sm="3" class="pt-2" style="min-height: 60px;">
          <template v-if="selected.length > 0">
            <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
            <v-menu offset-y left :disabled="selected.length === 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined
                       :disabled="selected.length === 0"
                       class="pl-0 pr-0"
                       min-width="36"
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="submitDialog = true; submitItem = null">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-col>
        <v-col cols="12" sm="9" class="pt-2">
          <v-slide-group class="text-right">
            <v-slide-item v-for="item in filters.category.value" :key="item.id">
              <v-chip
                      class="v-btn ml-3"
                      close
                      @click:close="removeCategory(item)"
                      color="#FAFCFF"
                      outlined
                      label
                      text-color="currentColor"
              >
                {{ getCategoryNameById(item) }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <!--<v-row>-->
        <!--<v-col cols="6">-->
          <!--<v-text-field-->
                  <!--v-model="search"-->
                  <!--append-icon="mdi-magnify"-->
                  <!--label="Поиск"-->
                  <!--single-line-->
                  <!--otlined-->
                  <!--hide-details-->
          <!--&gt;</v-text-field>-->
        <!--</v-col>-->
      <!--</v-row>-->
      <v-data-table
              no-data-text="Нет ингрендиентов"
              no-results-text="По заданному запросу ничего не найдено"
              v-model="selected"
              :headers="headers"
              :items="modifiers"
              :search="search"
              :options.sync="options"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :fixed-header="true"
              height="61vh"
              :footer-props="footerProps"
              :server-items-length="totalProducts"
              :loading="loading"
              :items-per-page="15"
              loading-text="Загрузка ингредиентов... Подождите пожалуйста"
              show-select
      >
        <template v-slot:item.price="{ item, index }">
          {{ item.price }} UAH
        </template>
        <template v-slot:item.image="{ item, index }">
          <template v-if="item.image">
            <v-img :src="item.image.url" :width="40" :height="32"></v-img>
          </template>
        </template>
        <template v-slot:header.category.name>
          Категория<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.category.value.length > 0}"
                 @click.stop.prevent="filters.category.modal = !filters.category.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'modifier-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="filters.category.modal"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
                  :items="categories"
                  :item-text="category => category.name"
                  :item-value="category => category.id"
                  v-model="filters.category.tempValue"
                  label="Категории"
                  :clearable="true"
                  outlined
                  multiple
                  :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.category.tempValue.length }}
                  </span>
            </template>
          </v-select>
          <div class="text-right mt-3">

          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setCategoryFilter">Выбрать</v-btn>
          <v-btn
                  outlined
                  @click="filters.category.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import ModifierService from './../../api/ModifierService'
  import TagService from "../../api/TagService";
  import ProductService from "../../api/ProductService";

  export default {
    name: 'ModifierIndex',
    components: {},
    data: () => ({
      submitDialog: false,
      submitItem: null,
      selected: [],
      filters: {
        category: {
          value: [],
          tempValue: [],
          modal: false,
        },
      },
      overlay: false,
      search: '',
      loading: true,
      categories: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Блюд на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [15, 30, -1]
      },
      totalProducts: 0,
      headers: [
        {
          text: 'Ингредиент',
          value: 'name',
        },
        {
          text: 'Категория',
          value: 'category.name'
        },
        {
          text: 'Изображение',
          value: 'image',
          sortable: false,
        },
        {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
      ],
      modifiers: [],
    }),
    mounted() {
      ModifierService.getCategoryList().then(response => {
        this.categories = response.data
      });
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      "filters.category.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        this.getDataFromApi()
      }
    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeModifer(item)
        } else {
          this.massDelete()
        }
      },
      removeCategory(id){
        this.filters.category.tempValue.splice(this.filters.category.tempValue.indexOf(this.filters.category.tempValue.find(category => category.id == id)) - 1, 1);
        this.setCategoryFilter()

      },
      getCategoryNameById(id){
        return this.categories.find(category => category.id == id).name;
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      massDelete(){
        let params = {
          ids: this.collectSelectedId()
        };

        ModifierService.massEdit('delete', params).then(response => {
          this.getDataFromApi()
        })
      },
      removeModifer(item){
        ModifierService.remove(item.id).then(response => {
          this.loading = true
          this.getDataFromApi()
        })
      },
      setCategoryFilter(e) {
        this.filters.category.value = this.filters.category.tempValue
        this.filters.category.modal = false;
        this.overlay = false;
      },
      getDataFromApi() {
        this.loading = true
        this.selected = [];
        let params = {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
          sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
          search: this.search,
          categories: this.filters.category.value,
        }
        ModifierService.list(params)
          .then(response => {
            this.modifiers = response.data.data
            this.totalProducts = response.data.total
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
